<template>
  <div :class="iconClass" :style="iconStyle" @click="$emit('click', $event)">
    <slot />
  </div>
</template>

<script>
export default {
  props: ['width', 'height'],
  computed: {
    iconStyle() {
      return {
        width: this.width || '24px',
        height: this.height || '24px',
      };
    },
    iconClass() {
      return this.$listeners.click && 'clickable';
    },
  },
}
</script>
